import { Box } from '@mui/material';
import * as React from 'react';
import { useQuestionForm } from '../../hooks/useQuestionForm';
import { QuestionFormProps } from '../../types/questionnaire.types';
import { ConfirmationDialog } from './ConfirmationDialog';
import { NavigationButtons } from './NavigationButtons';
import { QuestionCard } from './QuestionCard';
import { QuestionFormHeader } from './QuestionFormHeader';

export const QuestionFormAdvanced: React.FC<QuestionFormProps> = ({
  questions,
  onSubmit,
  submitButtonText = 'ENVIAR RESPOSTAS',
  timeLimit = 0,
}) => {
  // const [alreadyAnswered, setAlreadyAnswered] = React.useState(false);
  // const [checkingStatus, setCheckingStatus] = React.useState(true);

  const {
    responses,
    updateResponse,
    updateCheckboxResponse,
    updateMatrixResponse,
    updateEssayResponse,
    currentQuestion,
    goToQuestion,
    handleNext,
    handleBack,
    canGoBack,
    canGoNext,
    canProceed,
    isCurrentAnswered,
    isValid,
    answeredCount,
    showConfirmDialog,
    setShowConfirmDialog,
    handleSubmitClick,
    handleFinalSubmit,
  } = useQuestionForm({ questions, onSubmit, timeLimit });

  // React.useEffect(() => {
  //   const controller = new AbortController();

  //   const checkPesquisaStatus = async () => {
  //     try {
  //       setCheckingStatus(true);
  //       const status = await questionnaireService.getStatusPesquisa(
  //         controller.signal
  //       );

  //       if (status.isFinished === 1) {
  //         setAlreadyAnswered(true);
  //       }
  //     } catch (error) {
  //       // Ignora erros de abort (unmount) — os demais deixamos passar
  //       if (error instanceof Error && error.name !== 'AbortError') {
  //         console.error('Erro ao verificar status da pesquisa:', error);
  //       }
  //     } finally {
  //       setCheckingStatus(false);
  //     }
  //   };

  //   checkPesquisaStatus();

  //   return () => {
  //     controller.abort();
  //   };
  // }, []);

  // if (checkingStatus) {
  //   return (
  //     <Box
  //       sx={{
  //         display: 'flex',
  //         justifyContent: 'center',
  //         alignItems: 'center',
  //         minHeight: '200px',
  //       }}
  //     >
  //       <CircularProgress />
  //     </Box>
  //   );
  // }

  // if (alreadyAnswered) {
  //   return (
  //     <Dialog
  //       open
  //       maxWidth="sm"
  //       fullWidth
  //       PaperProps={{
  //         sx: {
  //           borderRadius: '16px',
  //           p: 2,
  //         },
  //       }}
  //     >
  //       <DialogTitle
  //         sx={{
  //           fontFamily: 'Roboto-Bold !important',
  //           fontSize: '14pt !important',
  //           color: '#374151',
  //           textAlign: 'center',
  //           pb: 1,
  //         }}
  //       >
  //         PESQUISA JÁ RESPONDIDA
  //       </DialogTitle>
  //       <DialogContent>
  //         <Box sx={{ textAlign: 'center' }}>
  //           <Alert
  //             severity="info"
  //             sx={{ mt: 2, borderRadius: '8px', fontSize: '11pt' }}
  //           >
  //             Você já respondeu esta pesquisa anteriormente.
  //           </Alert>
  //           <Typography
  //             sx={{
  //               fontFamily: 'Roboto-Regular !important',
  //               fontSize: '11pt !important',
  //               color: '#6b7280',
  //               mt: 2,
  //             }}
  //           >
  //             Não é possível responder a mesma pesquisa mais de uma vez.
  //           </Typography>
  //         </Box>
  //       </DialogContent>
  //       <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
  //         <Button
  //           onClick={() => window.history.back()}
  //           variant="contained"
  //           sx={{
  //             width: { xs: '100%', sm: '10rem' },
  //             background:
  //               'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important',
  //             color: '#ffffff',
  //             fontFamily: 'Roboto-Bold !important',
  //             fontSize: '10pt !important',
  //             textTransform: 'uppercase',
  //             borderRadius: '10px',
  //             px: 3,
  //             boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
  //             '&:hover': {
  //               background:
  //                 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important',
  //               boxShadow: '0 6px 16px rgba(59, 130, 246, 0.4)',
  //             },
  //           }}
  //         >
  //           Voltar
  //         </Button>
  //       </DialogActions>
  //     </Dialog>
  //   );
  // }

  const currentQuestionData = questions[currentQuestion];
  const isLastQuestion = currentQuestion === questions.length - 1;

  return (
    <>
      <QuestionFormHeader
        questions={questions}
        responses={responses}
        currentQuestion={currentQuestion}
        onStepClick={goToQuestion}
      />

      <Box sx={{ maxWidth: 1400, mx: 'auto', p: 2 }}>
        <QuestionCard
          question={currentQuestionData}
          questionNumber={currentQuestion + 1}
          response={responses[currentQuestionData.id]}
          isAnswered={isCurrentAnswered}
          onResponseChange={updateResponse}
          onCheckboxChange={updateCheckboxResponse}
          onMatrixChange={updateMatrixResponse}
          onEssayChange={updateEssayResponse}
          onRankingChange={updateResponse}
        />

        <NavigationButtons
          canGoBack={canGoBack}
          canGoNext={canGoNext}
          canProceed={canProceed}
          isLastQuestion={isLastQuestion}
          isFormValid={isValid}
          onBack={handleBack}
          onNext={handleNext}
          onSubmit={handleSubmitClick}
          submitButtonText={submitButtonText}
        />

        {/* onConfirm agora recebe Promise<void> — erros sobem para o ConfirmationDialog */}
        <ConfirmationDialog
          open={showConfirmDialog}
          onClose={() => setShowConfirmDialog(false)}
          onConfirm={handleFinalSubmit}
          answeredCount={answeredCount}
          totalQuestions={questions.length}
        />
      </Box>
    </>
  );
};

export default QuestionFormAdvanced;

// import {
//   Alert,
//   Box,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Typography,
// } from '@mui/material';
// import * as React from 'react';
// import { useQuestionForm } from '../../hooks/useQuestionForm';
// import { questionnaireService } from '../../services/questionnaireService';
// import { QuestionFormProps } from '../../types/questionnaire.types';
// import { ConfirmationDialog } from './ConfirmationDialog';
// import { NavigationButtons } from './NavigationButtons';
// import { QuestionCard } from './QuestionCard';
// import { QuestionFormHeader } from './QuestionFormHeader';

// export const QuestionFormAdvanced: React.FC<QuestionFormProps> = ({
//   questions,
//   onSubmit,
//   submitButtonText = 'ENVIAR RESPOSTAS',
//   timeLimit = 0,
//   // dadosServidor,
//   // isSubmitting: externalIsSubmitting,
// }) => {
//   const [alreadyAnswered, setAlreadyAnswered] = React.useState(false);
//   const [checkingStatus, setCheckingStatus] = React.useState(true);

//   const {
//     responses,
//     updateResponse,
//     updateCheckboxResponse,
//     updateMatrixResponse,
//     updateEssayResponse,
//     currentQuestion,
//     goToQuestion,
//     handleNext,
//     handleBack,
//     canGoBack,
//     canGoNext,
//     canProceed,
//     isCurrentAnswered,
//     isValid,
//     answeredCount,
//     showConfirmDialog,
//     setShowConfirmDialog,
//     handleSubmitClick,
//     handleFinalSubmit,
//   } = useQuestionForm({ questions, onSubmit, timeLimit });

//   React.useEffect(() => {
//     const controller = new AbortController();

//     const checkPesquisaStatus = async () => {
//       try {
//         setCheckingStatus(true);
//         const status = await questionnaireService.getStatusPesquisa(
//           controller.signal
//         );

//         if (status.isFinished === 1) {
//           setAlreadyAnswered(true);
//         }
//       } catch (error) {
//         console.error('Erro ao verificar status da pesquisa:', error);
//       } finally {
//         setCheckingStatus(false);
//       }
//     };

//     checkPesquisaStatus();

//     return () => {
//       controller.abort();
//     };
//   }, []);

//   // if (!dadosServidor) {
//   //   return null;
//   // }

//   if (checkingStatus) {
//     return null;
//   }

//   if (alreadyAnswered) {
//     return (
//       <Dialog
//         open
//         maxWidth="sm"
//         fullWidth
//         PaperProps={{
//           sx: {
//             borderRadius: '16px',
//             p: 2,
//           },
//         }}
//       >
//         <DialogTitle
//           sx={{
//             fontFamily: 'Roboto-Bold !important',
//             fontSize: '14pt !important',
//             color: '#374151',
//             textAlign: 'center',
//             pb: 1,
//           }}
//         >
//           PESQUISA JÁ RESPONDIDA
//         </DialogTitle>
//         <DialogContent>
//           <Box sx={{ textAlign: 'center' }}>
//             <Alert
//               severity="info"
//               sx={{ mt: 2, borderRadius: '8px', fontSize: '11pt' }}
//             >
//               Você já respondeu esta pesquisa anteriormente.
//             </Alert>
//             <Typography
//               sx={{
//                 fontFamily: 'Roboto-Regular !important',
//                 fontSize: '11pt !important',
//                 color: '#6b7280',
//                 mt: 2,
//               }}
//             >
//               Não é possível responder a mesma pesquisa mais de uma vez.
//             </Typography>
//           </Box>
//         </DialogContent>
//         <DialogActions
//           sx={{
//             justifyContent: 'center',
//             pb: 2,
//           }}
//         >
//           <Button
//             onClick={() => window.history.back()}
//             variant="contained"
//             sx={{
//               width: { xs: '100%', sm: '10rem' },
//               background:
//                 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important',
//               color: '#ffffff',
//               fontFamily: 'Roboto-Bold !important',
//               fontSize: '10pt !important',
//               textTransform: 'uppercase',
//               borderRadius: '10px',
//               px: 3,
//               boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
//               '&:hover': {
//                 background:
//                   'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important',
//                 boxShadow: '0 6px 16px rgba(59, 130, 246, 0.4)',
//               },
//             }}
//           >
//             Voltar
//           </Button>
//         </DialogActions>
//       </Dialog>
//     );
//   }

//   const currentQuestionData = questions[currentQuestion];
//   const isLastQuestion = currentQuestion === questions.length - 1;

//   return (
//     <>
//       <QuestionFormHeader
//         questions={questions}
//         responses={responses}
//         currentQuestion={currentQuestion}
//         onStepClick={goToQuestion}
//       />

//       <Box
//         sx={{
//           maxWidth: 1400,
//           mx: 'auto',
//           p: 2,
//         }}
//       >
//         <QuestionCard
//           question={currentQuestionData}
//           questionNumber={currentQuestion + 1}
//           response={responses[currentQuestionData.id]}
//           isAnswered={isCurrentAnswered}
//           onResponseChange={updateResponse}
//           onCheckboxChange={updateCheckboxResponse}
//           onMatrixChange={updateMatrixResponse}
//           onEssayChange={updateEssayResponse}
//           onRankingChange={updateResponse}
//         />

//         <NavigationButtons
//           canGoBack={canGoBack}
//           canGoNext={canGoNext}
//           canProceed={canProceed}
//           isLastQuestion={isLastQuestion}
//           isFormValid={isValid}
//           onBack={handleBack}
//           onNext={handleNext}
//           onSubmit={handleSubmitClick}
//           submitButtonText={submitButtonText}
//         />

//         <ConfirmationDialog
//           open={showConfirmDialog}
//           onClose={() => setShowConfirmDialog(false)}
//           onConfirm={handleFinalSubmit}
//           answeredCount={answeredCount}
//           totalQuestions={questions.length}
//         />
//       </Box>
//     </>
//   );
// };

// export default QuestionFormAdvanced;
